
import axios from 'axios'

import { uniqueId, imageFilter, stripParams } from '../../utils/utils.js'

var fetching = []

const state = {
  paginatedProducts: [],
  allProducts: [],
  currentPage: 1,
  allCollections: []
}

const mutations = {
  ADD_INIT_COLLECTION (state, collection) {
    state.paginatedProducts.push(...collection.products.slice(0, 36).map(product => ({ ...product, key: uniqueId() })));
  },
  SHOW_ALL_PRODUCTS(state) {
    state.paginatedProducts = state.allProducts;
    state.currentPage++;
  },
  ADD_FILTER_PRODUCTS(state, collection) {
    state.allProducts.push(...collection.products.map(product => ({ ...product, key: uniqueId() })));
  },
  ADD_COLLECTION(state, collection) {
    let index = state.allCollections.find(c => c.id === c.id)

    fetching.splice(fetching.indexOf(collection.handle), 1)
    if (index > -1) {
      state.allCollections.splice(index, 1, collection)
    } else {
      state.allCollections.push(collection)
    }
  }
}

const loadCollection = async (handle, limit) => {
  const productsRequest = axios.get(`/collections/${handle}/products.json?limit=${limit}`);
  const metafieldsRequest = axios.get(`/collections/${handle}?view=metafields-json`);
  const [productsResponse, metafieldsResponse] = await Promise.all([ productsRequest, metafieldsRequest ])
  // if in the theme editor, remove the comments injected into the metafields section
  // also parse the string into an array
  let metafieldsData = metafieldsResponse.data
  if (window.DesignMode) {
    metafieldsData = metafieldsData.replace(/<!--.*-->/g, '')
    metafieldsData = JSON.parse(metafieldsData)
  }
  let collection = formatCollectionData(productsResponse.data.products, metafieldsData)
  return collection
}

const actions = {
  async initCollection ({ commit }, handle, index) {
    /* used on collection page init,
    the first call only gets the first page to reduce the size of the call,
    then the rest are retrieved after */
    const initialCollectionData = await loadCollection(handle, 250);

    commit('ADD_INIT_COLLECTION', initialCollectionData)

    initialCollectionData.products.map((prod, index) => {
      prod.collections = handle;
    });

    commit('ADD_FILTER_PRODUCTS', initialCollectionData)    
  },

  async addCollection ({ commit }, handle) {
    //used to push many collections into the state
    if (fetching.indexOf(handle) < 0) {
      fetching.push(handle)
      const collectionData = await loadCollection(handle, 250)
      commit('ADD_COLLECTION', collectionData)
    }
  },
  showAllProducts({commit}) {
    commit('SHOW_ALL_PRODUCTS', state.allProducts);
  }
}

const formatCollectionData = (productData, metafieldData) => {
  const products = productData.map((product, index) => {

    const metafields = metafieldData.find(m => m.id === product.id);

    const imagesFormatted = product.images.map(image => {
      return {
        src: image.src,
        width: image.width,
        height: image.height
      }
      
    })

    let variantsFormatted = product.variants.map(variant => {

      let variantImage = () => {
        if (variant.featured_image) {
          return imageFilter(variant.featured_image.src, 400)
        } else {
          return imagesFormatted[0] ? imageFilter(imagesFormatted[0].src, 400) : ''
        }
      }

      let variantImageAlt = () => {
        if (variant.featured_image && variant.featured_image.alt) {
          return stripParams(variant.featured_image.alt)
        }
        else {
          return variant.option1
        }
      }

      let variantHasImage = () => {
        if (variant.featured_image) {
          return true
        } else {
          return false
        }
      }

      return {
        title: variant.title,
        id: variant.id,
        url: '/products/' + product.handle,
        available: variant.available,
        price: variant.price * 100,
        compare_at_price: variant.compare_at_price * 100,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        image: variantImage(),
        imageAlt: variantImageAlt(),
        has_image: variantHasImage()
      }
    })

    let sizeArray = () => {
      let sizes = product.variants.map(variant => {
        if (variant.option2) {
          return variant.option2
        }
      })
      let sizesNew = [...new Set(sizes)]
      let filteredSizes = sizesNew.filter(item => item !== undefined)
      return filteredSizes
    }

    return {
      title: product.title,
      handle: product.handle,
      id: product.id,
      index: index,
      collections: product.collections || product.collection,
      vendor: product.vendor,
      url: '/products/' + product.handle,
      images: imagesFormatted,
      description: product.body_html,
      price: parseFloat(product.variants[0].price * 100),
      compareAtPrice: parseFloat(product.variants[0].compare_at_price * 100),
      tags: product.tags,
      metafields: metafields,
      options: product.options,
      variants: variantsFormatted,
      filters: {
        style: !!metafields ? metafields.filter.style : [],
        color: !!metafields ? metafields.filter.color : [], 
        size: sizeArray(),
      },
      currentImage: variantsFormatted[0].image,
      currentImageAlt: variantsFormatted[0].imageAlt,
    }
  })

  let formattedData = {
    products: products
  }

  return formattedData
}

export default { namespaced: true, state, mutations, actions }
